<template>
  <div class="collapsible-section" :class="{ 'has-error': hasErrors }">
    <div class="header" @click="toggle">
      <div>
        <strong>Qualifications </strong>
        <AppTypography style="font-size: 10px; color: red;" type="body-1" class="mb-4 ml-2">(All SupportApp Workers have an ABN)</AppTypography>
        <!-- <div class="desc">Tell us what documents and qualifications are required from support workers.</div> -->
      </div>
      <v-btn icon variant="text" class="chevron-btn">
        <v-icon>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </div>
    <v-expand-transition>
      <div v-show="expanded || (qualifications_needed?.length || 0) > 0">
        <v-form class="qualifications-needed">
          <SelectQualifications 
            v-model="qualifications_needed" 
            :loading="fetching" 
            :disabled="updating" 
          />
        </v-form>
      </div>
    </v-expand-transition>
    <!-- Display validation errors outside the collapsible section -->
    <!-- <div v-if="hasErrors && !expanded" class="validation-errors">
        <div v-for="error in errorMessages" :key="error" class="error-message">
          {{ error }}
        </div>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import SelectQualifications from '@/components/fields/SelectQualifications.vue';
import useSupportRequirement from '@/modules/auth/composables/useSupportRequirement';
import type { Qualification } from '@/modules/auth/types/Auth';
import { ref, computed } from 'vue';

interface Props {
  errors?: {
    qualifications?: any[];
  };
}

const props = defineProps<Props>();

const expanded = ref(false);
const { fetching, updating } = useSupportRequirement();
const qualifications_needed = defineModel<Qualification[]>('qualifications_needed');

// Compute validation error state
const hasErrors = computed(() => {
  return props.errors?.qualifications && props.errors.qualifications.length > 0;
});

const errorMessages = computed(() => {
  if (!props.errors?.qualifications) return [];
  return props.errors.qualifications.map((error: any) => error.$message || error.message || 'This field is required');
});

function toggle() {
  expanded.value = !expanded.value;
}
</script>

<style scoped>
.collapsible-section {
  margin-bottom: 2rem;
  background: #fafafa;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  padding: 1.5rem;
}

.collapsible-section.has-error {
  border: 1px solid #ff5252;
  background: #fff5f5;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.header-right {
  display: flex;
  align-items: center;
}
.chevron-btn {
  margin-left: 1rem;
}
.desc {
  font-size: 0.95em;
  color: #555;
}
.validation-errors {
  margin-top: 0.5rem;
}
.error-message {
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  color: red;
}
.error-message:last-child {
  margin-bottom: 0;
}
.error-icon {
  font-size: 1.125rem;
}
</style>
